import { isTokenExpired } from '@utils';
import { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { appRoutes, AppRoute } from './router.config';

declare const abp: any;

export const RequireAuth = () => {
  const location = useLocation();
  const tokenExpired = isTokenExpired();

  const route = useMemo(
    () => appRoutes.find((r: AppRoute) => r.path === location.pathname),
    [location.pathname]
  );

  if (tokenExpired || !abp.session.userId) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!abp.session.tenantId && location.pathname === '/') {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  if (route && route.permission && !abp.auth.isGranted(route.permission)) {
    return (
      <Navigate
        to={abp.session.tenantId ? '/calendar' : '/dashboard'}
        state={{ from: location }}
        replace
      />
    );
  }

  return <Outlet />;
};
